import {
  levelsEnum,
  recordError as logError
} from "@seims/shared/src/utils/logService";
import { APPLICATION_NAMES } from "@seims/shared/src/constants";
import * as logger from "loglevel";

logger.enableAll(true);
logger.setLevel(logger.levels.INFO);

export const recordError = (err, selectedLevel = levelsEnum.ERROR) => {

  logError(err, selectedLevel, APPLICATION_NAMES.PUBLIC_PORTAL);
};

export default logger;
